import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';


import Moment from 'react-moment';
import moment from 'moment';

// import Linkify from 'react-linkify';

/* import {
  Row,
  Col,
} from 'reactstrap'; */


import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Media from 'reactstrap/lib/Media';
import Popover from 'reactstrap/lib/Popover';
import PopoverBody from 'reactstrap/lib/PopoverBody';
import LinkifyWithTargetBlank from '../UI/LinkifyWithTargetBlank';

import FileModal from '../UI/FileModal';
import DateFormat from '../UI/DateFormat';
import * as constants from '../../../constants/constants';

import computerImg from '../../../images/icons/computer.png';
import androidImg from '../../../images/icons/android.svg';
import iosImg from '../../../images/icons/apple.svg';
import draugiemImg from '../../../images/icons/draugiem.svg';
import facebookImg from '../../../images/icons/facebook.svg';
import inboxImg from '../../../images/icons/inbox.svg';
import tabletImg from '../../../images/icons/tablet.svg';
import phoneImg from '../../../images/icons/phone.svg';
import mobileWeb from '../../../images/icons/mobile-browser-development.svg';
import MessageAppInfo from './components/UserMessages/messageAppInfo';
import { breakLongWord } from '../../../utils/stringUtils';

import pencilImg from '../../../images/icons/pencil.svg';
import cancelImg from '../../../images/icons/close_old.png';
import checkImg from '../../../images/icons/check.png';
import { UncontrolledPopover } from 'reactstrap';

// const AdminSupportMessage = ({ message }) => {


class AdminSupportMessage extends React.Component {
  static propTypes = {
    message: PropTypes.shape(),
    chatMessagesUserLastLanguage: PropTypes.string,
    toggleEditModal: PropTypes.func,
    toggleDeleteConfirmModal: PropTypes.func,
    messageKey: PropTypes.string,
  };

  static defaultProps = {
    message: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false,
      modalOpen: false,
      modalFile: '',
      modalFileName: '',
      editPopoverOpen: false,
    };
  }

  onHover = (key) => {
    //  console.log('onHover', { key, old: this.state.popoverOpen });
    if (!this.state.popoverOpen) {
      this.setState({
        popoverOpen: key,
      });
    }
  }

  onHoverLeave = () => {
    this.setState({
      popoverOpen: false,
    });
  }

  openFileLink = (modalFile, modalFileName) => {
    this.setState({
      modalFile,
      modalFileName,
      modalOpen: true,
    });
    // window.open(modalFile, "_blank");
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen,
    }));
  }

  renderDeviceIcon = (device, message) => {
    let deviceInfo = device ? device.toLowerCase() : '';
    if (!deviceInfo && (message.env === 'ios' || message.env === 'android')) {
      deviceInfo = message.env.toLowerCase();
    }
    switch (deviceInfo) {
      case 'tablet':
        return <Media src={tabletImg} className="admin-chat-env" />
      case 'web':
        return <Media src={computerImg} className="admin-chat-env" />
      case 'dweb':
        return <Media src={computerImg} className="admin-chat-env" />
      case 'mobile':
        return <Media src={phoneImg} className="admin-chat-env" />
      case 'android':
        return <Media src={androidImg} className="admin-chat-env" />
      case 'ios':
        return <Media src={iosImg} className="admin-chat-env" />
      default:
        return <Media src={computerImg} className="admin-chat-env" />;
    }
  }

  render() {
    const { message, chatMessagesUserLastLanguage, toggleEditModal, toggleDeleteConfirmModal, messageKey, t } = this.props;
    const { editPopoverOpen, popoverOpen, modalOpen, modalFile, modalFileName } = this.state;

    const editedTag = messageKey && message.edited && (
      <>
        <p
          id={`edited-${messageKey}`}
          style={{color: 'rgb(236, 198, 109)', lineHeight: '20px', marginBottom: 0, float: 'right', cursor: 'pointer' }}
          onMouseEnter={() => this.setState({ editPopoverOpen: true })}
          onMouseLeave={() => this.setState({ editPopoverOpen: false })}
        >
          [edited]
        </p>

        <Popover
          container={'div > div'}
          popperClassName="last-round-popover"
          placement="right"
          isOpen={editPopoverOpen}
          target={`edited-${messageKey}`}
        >
          <PopoverBody className="last-round-popover-body">
            <DateFormat
              formatType={constants.FORMAT_DATE_TYPE.fullDateMinute}
              date={moment(message.edited)}
            />
          </PopoverBody>
        </Popover>
      </>
    );

    const editActions = messageKey && !message.userUid && !message.translationKey && (
      <div style={{position: 'relative', color: 'black', width: '100%', height: 50, marginTop: 25, pointerEvents: 'none'}}>
        <div style={{ pointerEvents: 'all' }}>
          <div
            className="event-banner-edit"
            style={{ position: 'absolute', top: '0px', right: '110px' }}
          >
            <Media
              style={{ width: '24px', height: '24px' }}
              onClick={() => toggleEditModal(messageKey)}
              src={pencilImg}
              className="menu-player-edit-image"
            />
          </div>

          <div
            className="event-banner-cancel"
            style={{ position: 'absolute', top: '0px', right: '85px' }}
          >
            <Media
              style={{ width: '24px', height: '24px' }}
              onClick={() => toggleDeleteConfirmModal(messageKey)}
              src={cancelImg}
              className="menu-player-edit-image"
            />
          </div>
        </div>
      </div>
    );

    if (message.isFiltered && message.filteredMessage && message.message) {
      let splitMessage = [];
      let splitFilteredMessage = [];

      splitMessage = message.message.split(/\n/);

      splitFilteredMessage = message.filteredMessage.split(/\n/);

      return (
        <Fragment>
          {!message.userUid ? (
            <Fragment>
              {message.date && (
                <div className="admin-chat-date-admin" style={{}}>
                  <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateMinute} date={moment(message.date)} />
                  {message.osVersion && <MessageAppInfo message={message} />}
                </div>
              )}
              <LinkifyWithTargetBlank>
                <div className="admin-chat-message-admin message">
                  {message.translationKey ? (
                    <p style={{ marginBottom: 0, lineHeight: '20px', wordBreak: 'break-word' }}>
                      {t(`support.${message.translationKey}`, { ...message.translationKeyData, lng: chatMessagesUserLastLanguage })}
                    </p>
                  ) : (
                    <>
                      {splitMessage.map(row => (
                        <p style={{ marginBottom: 0, lineHeight: '20px' }}>
                          {row}
                        </p>
                      ))}
                      {editedTag}
                    </>
                  )}
                  <a onClick={() => this.openFileLink(message.fileUpload || '', message.fileName || '')}>{message.fileName ? message.fileName : ''}</a>
                </div>
              </LinkifyWithTargetBlank>
            </Fragment>
          ) : (
            <Row style={{
              marginTop: 5, marginBottom: 5, paddingLeft: 10, paddingTop: 5, paddingBottom: 5,
            }}
            >
              <Col
                md="12"
                className="message"
                style={{ paddingLeft: 0 }}
              >
                {this.renderDeviceIcon(message.device ? message.device.toLowerCase() : '', message)}
                {message.date && (
                  <div className="admin-chat-date-user d-flex flex-column">
                    <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateMinute} date={moment(message.date)} />
                    {message.env && (
                      <MessageAppInfo message={message} />
                    )}
                  </div>
                )}
                <LinkifyWithTargetBlank>
                  <div className="admin-chat-message-user">
                    {/*  {splitMessage.map(row => (
                      <p key={row} style={{ marginBottom: 0, lineHeight: '20px' }}>
                        {row}
                      </p>
                    ))}  */}
                    {splitFilteredMessage.map((row, index) => {
                      let words = [];
                      if (splitMessage[index]) {
                        words = splitMessage[index].split(' ');
                      }
                      const filteredWords = row.split(' ');

                      return (
                        <div key={index}>
                          {filteredWords.map((word, index2) => (
                            <>
                              {(words && words[index2] !== word) ? (
                                <>
                                  <div
                                    style={{ display: 'inline-block', marginRight: 2 }}
                                    id={`chat-popover-${message.messageId}-${index2}`}
                                    onMouseEnter={() => this.onHover(`${message.messageId}-${index2}`)}
                                    onMouseLeave={this.onHoverLeave}
                                  >
                                    {`${word} `}
                                  </div>
                                  <Popover container={'div > div'} popperClassName="last-round-popover" placement="top" isOpen={popoverOpen === `${message.messageId}-${index2}`} target={`chat-popover-${message.messageId}-${index2}`}>
                                    <PopoverBody className="last-round-popover-body">
                                      {/*  {`${words[index2]}`} */}
                                      {`${message.message}`}
                                    </PopoverBody>
                                  </Popover>
                                </>
                              ) : (
                                <>
                                  {`${word} `}
                                </>
                              )}
                            </>
                          ))}
                          <a onClick={() => this.openFileLink(message.fileUpload || '', message.fileName || '')}>{message.fileName ? message.fileName : ''}</a>
                        </div>
                      );
                    })}

                  </div>
                </LinkifyWithTargetBlank>
              </Col>
            </Row>
          )}
          <FileModal fileUpload={modalFile} fileName={modalFileName} toggleModal={this.toggleModal} modalOpen={modalOpen} adminPanelOpen />

          {editActions}
        </Fragment>
      );
    }
    {
      const splitMessage = message.message.split(/\n/);
      return (
        <Fragment>
          {!message.userUid ? (
            <Fragment>
              {message.date && (
                <div className="admin-chat-date-admin">
                  <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateMinute} date={moment(message.date)} />
                  {message.osVersion && <MessageAppInfo message={message} />}
                </div>
              )}
              <LinkifyWithTargetBlank>
                <div className="admin-chat-message-admin message">
                  {message.translationKey ? (
                    <p style={{ marginBottom: 0, lineHeight: '20px', wordBreak: 'break-word' }}>
                      {t(`support.${message.translationKey}`, { ...message.translationKeyData, lng: chatMessagesUserLastLanguage })}
                    </p>
                  ) : (
                    <>
                      {splitMessage.map(row => (
                        <p style={{ marginBottom: 0, lineHeight: '20px' }}>
                          {breakLongWord(row, 34, {color: 'rgb(255, 132, 0)', textDecoration: 'underline'})}
                        </p>
                      ))}
                      {editedTag}
                    </>
                  )}
                  

                  <a onClick={() => this.openFileLink(message.fileUpload || '', message.fileName || '')} >{message.fileName || ''}</a>
                </div>
              </LinkifyWithTargetBlank>
            </Fragment>
          ) : (
            <Row style={{
              marginTop: 5, marginBottom: 5, paddingLeft: 10, paddingTop: 5, paddingBottom: 5,
            }}
            >
              <Col
                md="12"
                className="message"
                style={{ paddingLeft: 0 }}
              >
                {this.renderDeviceIcon(message.device ? message.device.toLowerCase() : '', message)}

                {message.date && (
                  <div className="admin-chat-date-user">
                    <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateMinute} date={moment(message.date)} />
                    {message.env && (
                      <MessageAppInfo message={message} />
                    )}
                  </div>
                )}
                <LinkifyWithTargetBlank>
                  <div className="admin-chat-message-user">
                    {splitMessage.map(row => (
                      <p key={row} style={{ marginBottom: 0, lineHeight: '20px' }}>
                        {breakLongWord(row, 34, {color: 'rgb(137, 198, 218)', textDecoration: 'underline'})}
                      </p>
                    ))}
                    <a onClick={() => this.openFileLink(message.fileUpload || '', message.fileName || '')} >{message.fileName || ''}</a>
                  </div>
                </LinkifyWithTargetBlank>
              </Col>
            </Row>
          )}
          <FileModal fileUpload={modalFile} fileName={modalFileName} toggleModal={this.toggleModal} modalOpen={modalOpen} adminPanelOpen />

          {editActions}
        </Fragment>
      );
    }
  }
}

/* AdminSupportMessage.propTypes = {
  message: PropTypes.shape(),
};

AdminSupportMessage.defaultProps = {
  message: {},
}; */

export default withTranslation("common")(AdminSupportMessage);
